import * as React from 'react';

export const IconDescription = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<g>
			<path d="M21.258 5.629H2.265a.424.424 0 0 1-.373-.134.493.493 0 0 1-.127-.401.493.493 0 0 1 .125-.4.424.424 0 0 1 .375-.136h18.993a.424.424 0 0 1 .375.133.493.493 0 0 1 .125.4.551.551 0 0 1-.5.534zm0 6.461H2.265a.424.424 0 0 1-.373-.132.493.493 0 0 1-.127-.4.493.493 0 0 1 .125-.4.424.424 0 0 1 .375-.137h18.993a.424.424 0 0 1 .375.133.493.493 0 0 1 .125.4.551.551 0 0 1-.5.534zm-7.83 6.461H2.265a.424.424 0 0 1-.375-.133.493.493 0 0 1-.125-.4.493.493 0 0 1 .125-.4.424.424 0 0 1 .375-.136h11.163a.424.424 0 0 1 .375.133.493.493 0 0 1 .125.4.493.493 0 0 1-.125.4.424.424 0 0 1-.375.133z" />
		</g>
	</svg>
);
